import React from 'react';
import { connect } from 'redux-bundler-react';
import IdentifySidebarList from './identify-sidebar-list';
import find from 'lodash/find';

class IdentifySidebar extends React.Component {
  constructor(props){
    super(props);
    this.renderResults = this.renderResults.bind(this);
  }

  renderResults(){
    const { identifyResults, cmLayerNames, uidMap } = this.props;
    const subLayerNameMatch = /[:](.+)/i;
    const components = [];
    let counter = 0;

    identifyResults.forEach((r) => {
      const id = r.dataset;
      let lyr;
      let lyrName;
      if(id!=='IWRSS' && id!=='SIMDAMS' && id!=='HSIP') {
        lyr = find(cmLayerNames, { teamDatasetId: id });
        lyrName = !lyr ? Object.keys(r.result)[0] : lyr.displayName;
      }else{
        lyrName = Object.keys(r.result)[0]
      }   

      Object.keys(r.result).forEach((key) => {
        const fc = r.result[key];
        if(fc && fc.features && fc.features.length){
          const subLayer = subLayerNameMatch.exec(key);
          const subLayerName = subLayer ? subLayer[1] !== lyrName ? subLayer[0] : '' : '';
          components.push(<IdentifySidebarList features={fc.features} displayName={`${lyrName}${subLayerName}`} key={counter++} />)
        }
      })
    })

    return components;
  }

  render(){
    const { doClosePrimaryPanel } = this.props;
    
    return (
      <div style={{marginTop:'6px', marginLeft:'6px', height:'100%'}}>
          <div style={{display:'inline-flex', alignItems:'baseline'}}>
            <span
              onClick={ doClosePrimaryPanel }
              style={{ position:'relative', fontSize:18, cursor:'pointer' }}
            >
              <i className="mdi mdi-arrow-left"></i>
            </span>
        </div>
        <div className="thin-scrollbar sidebar-list" style={{top:32}}>
          { this.renderResults() }
        </div>
      </div>
    )
  }
}

export default connect(
  'selectIdentifyResults',
  'selectCmLayerNames',
  'selectUidMap',
  'doClosePrimaryPanel',
  IdentifySidebar
)